import {NgModule} from '@angular/core';

import {EquipmentSelectComponent} from './equipment-select.component';
import {FormFieldModule} from '../form-field/form-field.module';
import {CommonModule} from '@angular/common';
import {LayoutModule} from '@layoutComponents/layout.module';
import {EquipmentPreviewComponent} from './components/equipment-preview/equipment-preview.component';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {ApparatusFormFieldsModule} from '@subforms/apparatus-form-fields/apparatus-form-fields.module';
import {EquipmentFormComponent} from './components/equipment-form/equipment-form.component';
import {EquipmentFormService} from './services/equipment-form.service';
import {ReactiveFormsModule} from '@angular/forms';
import {PagingControlModule} from '../paging-control/paging-control.module';
import {EquipmentService} from './services/equipment.service';
import {EquipmentFullViewComponent} from './components/equipment-full-view/equipment-full-view.component';
import {EquipmentSelectControlService} from './services/equipment-select-control.service';
import {IconsModule} from '@lab365/icons';

@NgModule({
    imports: [
        FormFieldModule,
        CommonModule,
        LayoutModule,
        DirectivesModule,
        ReactiveFormsModule,
        ApparatusFormFieldsModule,
        PagingControlModule,
        IconsModule,
    ],
    exports: [
        EquipmentSelectComponent,
        EquipmentPreviewComponent,
    ],
    declarations: [
        EquipmentSelectComponent,
        EquipmentPreviewComponent,
        EquipmentFormComponent,
        EquipmentFullViewComponent,
    ],
    providers: [
        EquipmentService,
        EquipmentFormService,
        EquipmentSelectControlService,
    ],
})
export class EquipmentSelectModule {

}
